// extracted by mini-css-extract-plugin
var _1 = "_branchesDeleteBranchModal-module__action-button";
var _2 = "_branchesDeleteBranchModal-module__form-action-button-disabled";
var _3 = "_branchesDeleteBranchModal-module__loader";
var _4 = "_branchesDeleteBranchModal-module__subcontainer";
export { _1 as "action-button", _2 as "form-action-button-disabled", _3 as "loader", _4 as "subcontainer" }
